<template>
    <div class="customFixed-vue">
    	<app-profile v-if="tab == 'Profile'"></app-profile>
    	<app-trading-view v-if="tab == 'Trading View'"></app-trading-view>
    	<app-reports-setting v-if="tab == 'Reports Setting'"></app-reports-setting>
    	<app-settings v-if="tab == 'Settings'"></app-settings>
        <app-grid-view-pop v-if="tab == 'Grid View Pop'"></app-grid-view-pop>
        <idle-session v-if="tab == 'Idle Session'"></idle-session>
        
    </div>
</template>

<script>
import profile from './sidebar-popup/profile'
import trading_view from './sidebar-popup/trading-view'
import reports_setting from './sidebar-popup/reports-setting'
import settings from './sidebar-popup/settings'
import grid_view_pop from './sidebar-popup/grid-view-pop'
import idle_session from './sidebar-popup/idle-session'
export default {
    name: 'sidebar-popup',
    data() {
        return {
            
        }
    },
    props:['tab'],
    components:{
    	appProfile : profile,
    	appTradingView : trading_view,
    	appReportsSetting : reports_setting,
    	appSettings : settings,
        gridView : grid_view_pop,
        idleSession : idle_session,
    }
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/sidebar-popup.vue